"use client";

import { Check } from "lucide-react";
import { useTranslations } from "next-intl";
import { CtaButton } from "@/components/ui/CtaButton";
import { useCopy } from "@/hooks/useCopy";
import { site } from "@/lib/site";

// Hero H1 + benefit bullets + CTA, driven by the `hero-headline` copy experiment.
// Client component so it can read the PostHog variant, but it server-renders the
// control copy first (SEO + LCP safe) and swaps to the assigned variant on flag load.
export function HeroHeadline() {
  const tx = useCopy("Hero", "hero-headline");
  const t = useTranslations("Hero");
  const bullets = t.raw("bullets") as string[];

  return (
    <>
      {/* Sized to dominate the fold the way the old Framer hero's did. Left
          unbalanced on purpose: text-balance evens the line lengths, which at
          this size reads as a centred block in a left-aligned column. */}
      {/* The measure is capped only from sm up. On a phone the 18ch cap fought
          the font size: it narrowed the column enough to push the headline onto
          a fourth line no matter how small the type got. */}
      <h1 className="mt-5 max-w-none text-[1.9rem] font-extrabold leading-[1.08] tracking-tight text-white sm:max-w-[18ch] sm:text-[3.5rem] sm:leading-[1.05] lg:text-[3.75rem] lg:leading-[1.03]">
        {tx("titleLead")} {tx("titleEm")}
      </h1>

      <ul className="mt-6 flex max-w-lg flex-col gap-3 text-base text-white/90 sm:text-lg">
        {bullets.map((bullet) => (
          <li key={bullet} className="flex items-start gap-3">
            <Check className="size-5 h-lh shrink-0 text-success" strokeWidth={3} />
            <span>{bullet}</span>
          </li>
        ))}
      </ul>

      <div className="mt-8">
        <CtaButton
          href={site.loginUrl}
          linkId="hero_cta"
          id="cta_hero_banner"
          size="xl"
          className="w-full sm:w-auto"
        >
          {tx("cta")}
        </CtaButton>
      </div>
    </>
  );
}
